<app-nav [isHome]="true"></app-nav>
<app-header></app-header>
<app-features></app-features>
<app-description></app-description>
<app-footer [isHome]="true"></app-footer>
